import { useEffect } from "react";

const resizeObserverErrorRegex =
  /^ResizeObserver loop (limit exceeded|completed with undelivered notifications\.)$/;

const getMessage = (errorLike) => {
  if (!errorLike) return "";
  if (typeof errorLike === "string") return errorLike;
  if (typeof errorLike.message === "string") return errorLike.message;
  return "";
};

const shouldIgnoreResizeObserverError = (message) => {
  if (!message) return false;
  return resizeObserverErrorRegex.test(message.trim());
};

const ResizeObserverComponent = () => {
  useEffect(() => {
    const handleWindowError = (event) => {
      const message = getMessage(event?.message || event?.error);
      if (!shouldIgnoreResizeObserverError(message)) return;
      event.preventDefault?.();
      event.stopImmediatePropagation?.();
    };

    const handleUnhandledRejection = (event) => {
      const message = getMessage(event?.reason);
      if (!shouldIgnoreResizeObserverError(message)) return;
      event.preventDefault?.();
      event.stopImmediatePropagation?.();
    };

    window.addEventListener("error", handleWindowError, true);
    window.addEventListener(
      "unhandledrejection",
      handleUnhandledRejection,
      true
    );

    return () => {
      window.removeEventListener("error", handleWindowError, true);
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection,
        true
      );
    };
  }, []);

  return null;
};

export default ResizeObserverComponent;
